export const fetchRooms = async (accessToken) => {
    try {
        const response = await fetch('https://graph.microsoft.com/beta/me/findRooms', {
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            const errorData = await response.json();
            console.error('Room fetch error details:', errorData);
            throw new Error(`Failed to fetch rooms: ${errorData.error?.message || 'Unknown error'}`);
        }

        const data = await response.json();
        return data.value;
    } catch (error) {
        console.error('Error fetching rooms:', error);
        throw error;
    }
};

export const getRoomAvailability = async (accessToken, roomEmail, startTime, endTime) => {
    try {
        const response = await fetch('https://graph.microsoft.com/v1.0/users/' + roomEmail + '/calendar/getSchedule', {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                schedules: [roomEmail],
                startTime: {
                    dateTime: startTime,
                    timeZone: 'UTC'
                },
                endTime: {
                    dateTime: endTime,
                    timeZone: 'UTC'
                }
            })
        });

        if (!response.ok) {
            const errorData = await response.json();
            console.error('Room availability error details:', errorData);
            return false;
        }

        const data = await response.json();

        return data.value[0].availabilityView === "0" || data.value[0].availabilityView === "00";
    } catch (error) {
        console.error('Error checking room availability:', error);
        return false;
    }
};